import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-header cursor-pointer p-9" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "fw-bolder m-0 mx-3" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex align-items-center mx-5"
}
const _hoisted_8 = {
  key: 0,
  href: "javacript:void(0)",
  class: "btn btn-sm btn-light-primary"
}
const _hoisted_9 = { class: "svg-icon svg-icon-3" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Connected ")
const _hoisted_11 = ["data-kt-indicator"]
const _hoisted_12 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_13 = { class: "svg-icon svg-icon-3" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Connect ")
const _hoisted_15 = { class: "indicator-progress" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_17 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}
const _hoisted_18 = { class: "card-body p-9" }
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download fs-4 me-2" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Document")
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "row mb-7 mt-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Name", -1)
const _hoisted_25 = { class: "col-lg-8" }
const _hoisted_26 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_27 = { class: "row mb-7" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Introduction", -1)
const _hoisted_29 = { class: "col-lg-8 fv-row" }
const _hoisted_30 = { class: "fw-bold fs-6" }
const _hoisted_31 = { class: "row mb-7" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Professional Summary", -1)
const _hoisted_33 = { class: "col-lg-8 fv-row" }
const _hoisted_34 = { class: "fw-bold fs-6" }
const _hoisted_35 = { class: "row mb-7" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Telephone ", -1)
const _hoisted_37 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_38 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_39 = { class: "row mb-7" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Job Title", -1)
const _hoisted_41 = { class: "col-lg-8" }
const _hoisted_42 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_43 = { class: "row mb-7" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " LinkedIn Profile ", -1)
const _hoisted_45 = { class: "col-lg-8" }
const _hoisted_46 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_47 = ["href"]
const _hoisted_48 = { class: "row mb-7" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " External Document ", -1)
const _hoisted_50 = { class: "col-lg-8" }
const _hoisted_51 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_52 = ["href"]
const _hoisted_53 = { class: "row mb-7" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Industry Sectors ", -1)
const _hoisted_55 = { class: "col-lg-8" }
const _hoisted_56 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_57 = { class: "row mb-7" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Expertise ", -1)
const _hoisted_59 = { class: "col-lg-8" }
const _hoisted_60 = { class: "fw-bolder fs-6 text-dark" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: 
                _ctx.op.get(_ctx.expert, 'user.profileImage', null) ??
                require('@/assets/img/blank.png')
              ,
              alt: "image"
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.expert.name), 1)
        ]),
        (_ctx.hasFounderRole)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.isConnected)
                ? (_openBlock(), _createElementBlock("a", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr012.svg" })
                    ]),
                    _hoisted_10
                  ]))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    "data-kt-indicator": _ctx.loading ? 'on' : null,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.attachExpert && _ctx.attachExpert(...args))),
                    href: "javascript:void(0)",
                    class: "btn btn-sm btn-light"
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
                          ]),
                          _hoisted_14
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_15, [
                      _hoisted_16,
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_11))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        (_ctx.expert.document)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              download: "",
              href: _ctx.expert.document,
              class: "btn btn-primary my-3"
            }, _hoisted_22, 8, _hoisted_19))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.expert.name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.expert.introduction), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.expert.bio), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.expert.telephone), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.expert.jobTitle), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("span", _hoisted_46, [
              _createElementVNode("a", {
                href: _ctx.op.get(_ctx.expert, 'linkedInProfileUrl', '#'),
                target: "_blank"
              }, _toDisplayString(_ctx.op.get(_ctx.expert, "linkedInProfileUrl", "None") ?? "None"), 9, _hoisted_47)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("span", _hoisted_51, [
              _createElementVNode("a", {
                href: _ctx.op.get(_ctx.expert, 'externalDocumentUrl', '#'),
                target: "_blank"
              }, _toDisplayString(_ctx.op.get(_ctx.expert, "externalDocumentUrl", "None") ?? "None"), 9, _hoisted_52)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _hoisted_54,
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.arrayStringConstructor(_ctx.op.get(_ctx.expert, "industrySectors", []))), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _hoisted_58,
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.arrayStringConstructor(_ctx.op.get(_ctx.expert, "expertise", []))), 1)
          ])
        ])
      ])
    ])
  ]))
}